import React from 'react';

import {Section} from '../containers';
import {FunFactItem} from '../elements';

const FunFacts = ({translate, api}) => {
	const {items} = api.getFunfacts();

	return (
		<Section id="funfacts" className="root-sec white lighten-5 funfacts-wrap" overlay={true}
				 overlayExtaClassName={'sec-inner padd-tb-120'}>
			<div className="row">
				<div className="funfact-inner">
					{items.map((item, index) => (<FunFactItem key={index} {...item} translate={translate}/>))}
				</div>
			</div>
		</Section>
	);
};

export default FunFacts;



// WEBPACK FOOTER //
// ./src/components/sections/FunFacts.js